const getColumns = (hasRightLabel = false) => (
  hasRightLabel
    ? [{
      name: '',
      size: 2,
      align: 'left',
      key: 'option',
    }, {
      name: '',
      size: 1,
      align: 'right',
      key: 'right-label',
    }]
    : [{
      name: '',
      size: 4,
      align: 'left',
      key: 'option',
    }]
);

export { getColumns };
